<template>
  <div class="trade-view-com">
    <div class="trade-chart-container" id="trade_chart_container"></div>
    <div class="loading-box" id="trade_loading">
      <div class="spinner">
        <div class="spinner-item" v-for="(val, index) in 17" :key="val" :style="{ 'animation-delay': index * 0.047 + 's' }">
          <div :style="{ transform: `rotate(${index * 21}deg) translate(30px, 0px)` }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './script/chart';
import Datafeeds from './script/datafeed';
import tools from '../../../../common/js/tool';

import { indexApi } from '../../../../api/indexApi';
import { socketName } from '../../../../common/constants/globalConfig';
import { mapGetters } from 'vuex';
import { getterTypes } from '../../../../store/getter-types';

export default {
  name: 'TradeView',
  data() {
    return {
      // 存储图表组件
      widget: null,
      dataFeed: {},
      dataCache: {},
      currentMarket: {},
      symbol: '',
      interval: '',
      // 请求后台的 参数
      reqInterval: '',

      langMap: {
        zh_CN: 'zh',
        en_US: 'en'
      },
      klineLang: 'zh',
      onRealtimeCallback: null,
      // 最后一次订阅的频道
      lastSubscribeChannel: '',
      klineData: [],
      firstRequest: false,
      currentInterval: '',
      zoom: null,
      placeOrderContainer: null,
      tradingViewContainer: null,
      activePairContainer: null,
      parentContainer: null,
      leftContainer: null,
      tradingViewInnerContainer: null,
      depthComponentContainer: null
    };
  },
  props: {
    activePair: {
      type: String,
      default: 'BTCUSDT'
    },
    activeInterval: {
      type: String,
      default: '1'
    },
    realTimeData: {
      type: Array,
      default() {
        return [];
      }
    },
    model: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    changeBtnStyle(dom) {
      tools.addClass(dom, 'mybtn');
      let parentNodes = tools.siblings(dom.parentNode);
      parentNodes.forEach(item => {
        tools.removeClass(item.childNodes[0], 'mybtn');
      });
    },
    async _requestFirstKline(symbol, reqInterval, resolution, from, to, callback) {
      let data = [];
      /**
       * Todo: monitor this line of code it could affect the kline loading
       */
      /* process first request */
      // if (this.firstRequest == false) {
      //   data = this.arrayToJSON(this.klineData).reverse();
      this.firstRequest = true;
      // process 2nd request
      // } else {
      data = await indexApi.getkline(symbol, reqInterval, to, from).then(res => {
        if (res.errcode === 0) {
          let data = res.data;
          return this.arrayToJSON(data.kline).reverse();
        }
      });
      // }
      if (data.length > 0) {
        callback && callback({ s: 'ok', bars: data });
      } else {
        callback && callback({ s: 'no_data' });
      }
    },
    init(options) {
      let that = this;
      this.dataFeed = new Datafeeds(this, 0); // new Datafeeds(this, 0);
      this.symbol = options.symbol;
      this.interval = options.interval;
      this.widget = new window.TradingView.widget({
        autosize: true,
        symbol: options.symbol,
        interval: options.interval,
        container_id: 'trade_chart_container',
        datafeed: this.dataFeed,
        library_path: '/charting_library/static',
        drawings_access: {
          type: 'black',
          tools: [{ name: 'Regression Trend' }]
        },
        disabled_features: [
          'header_symbol_search',
          'volume_force_overlay',
          'use_localstorage_for_settings',

          // 周围边框
          'border_around_the_chart',
          // 顶部工具栏
          // "header_widget_dom_node",
          'header_compare',
          'header_interval_dialog_button',
          // 前进后退
          'header_undo_redo',
          // 底部栏
          'timeframes_toolbar',
          'go_to_date',
          'symbol_info',
          // 右键菜单
          'context_menus',
          'header_screenshot',
          'header_chart_type'
          // 周期
          // 'header_resolutions',
          // 'header_fullscreen_button',
        ],
        enabled_features: ['side_toolbar_in_fullscreen_mode'],
        time_frames: [],

        favorites: {
          // intervals: ['5', '15', '30', '60', '240', '1D', '1W'],
          intervals: ['1', '5', '15', '30', '60'],
          chartTypes: ['Area']
        },
        has_weekly_and_monthly: true,
        numeric_formatting: {
          decimal_sign: '.'
        },
        timezone: 'Asia/Shanghai',
        locale: this.klineLang,
        debug: false,
        // 四周工具栏颜色
        // toolbar_bg:"#0a0a0a",
        toolbar_bg: '#121d26',
        studies_overrides: {
          // "volume.volume.color.0": "#fe4761",
          // "volume.volume.color.1": "#3fcfb4",
          // 交易量柱子颜色
          // "volume.volume.color.0": "rgba(232,67,82,1)",
          // "volume.volume.color.1": "rgba(73,176,124,1)",
          // TIP 交易量柱子颜色 设置rgb后 没有描边了 ,不设置Rgb 颜色就特别暗
          /* "volume.volume.color.0": "rgba(167,4,4,1)",
              "volume.volume.color.1": "rgba(3,89,3,1)", */
          'volume.volume.color.0': 'rgba(239,85,85,1)',
          'volume.volume.color.1': 'rgba(3,192,135,1)',
          // "volume.volume.transparency": 1,
          'volume.show ma': true
          // "MA Cross.short:plot.color": "#f60",
          // "MA Cross.long:plot.color": "#f60",
          // "volume.volume.color.0": "#035903",
          // "volume.volume.color.1": "#A70404",
          // 这种方式无效
          // "volume.volume.transparency": 100,
        },
        loading_screen: {
          // 主背景色
          backgroundColor: '#121d26'
          // backgroundColor:"#fff"
        },
        overrides: {
          // large, medium, small, tiny
          volumePaneSize: 'medium',
          // 默认symbol收缩起来
          'paneProperties.legendProperties.showLegend': true,
          'symbolWatermarkProperties.color': 'rgba(0,0,0, 0)',
          /* "paneProperties.background": "#0a0a0a",
              "paneProperties.vertGridProperties.color": "#0a0a0a",
              "paneProperties.horzGridProperties.color": "#0a0a0a", */
          'paneProperties.background': '#121d26',
          /* "paneProperties.vertGridProperties.color": "#fff",
              "paneProperties.horzGridProperties.color": "#fff", */
          // 水平网格
          'paneProperties.vertGridProperties.color': '#121d26',
          // 垂直网格
          'paneProperties.horzGridProperties.color': '#121d26',

          // 十字交叉线
          'paneProperties.crossHairProperties.color': '#eee',
          // "paneProperties.crossHairProperties.color": "#03c087",

          // 蜡烛样式 涨跌颜色
          /* "mainSeriesProperties.candleStyle.upColor": "#49b07c",
              "mainSeriesProperties.candleStyle.downColor": "#e84352", */
          'mainSeriesProperties.candleStyle.upColor': '#03c087',
          'mainSeriesProperties.candleStyle.downColor': '#ef5555',
          // "mainSeriesProperties.candleStyle.drawWick": true,
          'mainSeriesProperties.candleStyle.drawBorder': false,
          // "mainSeriesProperties.candleStyle.borderColor": "#ccc",
          // 蜡烛块的边框颜色（涨）
          // "mainSeriesProperties.candleStyle.borderUpColor": "#49b07c",
          'mainSeriesProperties.candleStyle.borderUpColor': '#03c087',
          // 蜡烛块的边框颜色（跌）
          // "mainSeriesProperties.candleStyle.borderDownColor": "#e84352",
          'mainSeriesProperties.candleStyle.borderDownColor': '#ef5555'
          // k线颜色（涨） 上下线
          // "mainSeriesProperties.candleStyle.wickUpColor": 'rgba( 115, 115, 117, 1)',
          // k线颜色（跌） 上下线
          // "mainSeriesProperties.candleStyle.wickDownColor": 'rgba( 115, 115, 117, 1)',
          // "mainSeriesProperties.candleStyle.barColorsOnPrevClose": false,

          // " mainSeriesProperties.lineStyle.color": "#f00",
          // "mainSeriesProperties.areaStyle.color1": "#f00",
          // "mainSeriesProperties.areaStyle.color2": "#0098c4",
          // "mainSeriesProperties.areaStyle.linecolor": "#0cbef3",
          // 刻度的设置
          // "scalesProperties.showLeftScale": false,
          // "scalesProperties.showRightScale": true,
          // "scalesProperties.backgroundColor": "#20334d",
          // "scalesProperties.lineColor": "#46587b",
          // "scalesProperties.textColor": "#8f98ad",
          // linetoolicon: {
          //   singleChartOnly: true,
          //   color: 'rgba( 255, 0, 0, 1)',
          //   snapTo45Degrees:true,
          //   size: 40,
          //   icon: 0x263A,
          //   angle: Math.PI * 0.5,
          //   scale: 1.0
          // },
        },
        custom_css_url: `trading-view-chart.css?_v=20190110162345`
      });
      this.widget.onChartReady(() => {
        this.getTradingViewContainer();
        // 移动均线（点击"+"号展开显示的部分）
        this.widget
          .chart()
          .createStudy('Moving Average', false, false, [5], null, { 'Plot.color': '#9f6dc8', 'Plot.linewidth': 2 });
        this.widget
          .chart()
          .createStudy('Moving Average', false, false, [10], null, { 'Plot.color': '#8eaad5', 'Plot.linewidth': 2 });
        this.widget
          .chart()
          .createStudy('Moving Average', false, false, [30], null, { 'Plot.color': '#6abb76', 'Plot.linewidth': 2 });
        this.widget
          .chart()
          .createStudy('Moving Average', false, false, [60], null, { 'Plot.color': '#8b248a', 'Plot.linewidth': 2 });
        // 随机指标
        // this.widget.chart().creaeStudy('Stochastic', false, false, [26], null, {"%d.color":"#ff0000"})
        this.widget
          .chart()
          .onIntervalChanged()
          .subscribe(null, interval => {
            this.dataCache = {};
            this.reqInterval = this.parseInterval(this.interval);
            // dealProfessional.subscribeToGetExchangeData('setList', this.symbol, this.reqInterval, 'D3');
            // this.$socket.unsubscribe(`market.${this.symbol.toLowerCase()}.kline.${this.reqInterval}`, 'market-kline');
            // this.unSubscribeKLine();
            this.interval = interval;
          });
        let _that = this;
        // this.widget.chart().executeActionById("undo");
        // this.widget.chart().executeActionById("drawingToolbarAction");
        //  自定义按钮 1分钟、5分钟、10分钟
        /* this.widget.createButton()
            .attr('title', this.$t('kline.0m'))
            .text(this.$t('kline.0m'))
            .on('click', function (e) {
              _that.changeBtnStyle(this);
              _that.widget.chart().setResolution('1', function onReadyCallback () {});
              // 分时图
              _that.widget.chart().setChartType(3);
            });

          this.widget.createButton()
            .attr('title', this.$t('kline.1m'))
            .text(this.$t('kline.1m'))
            .on('click', function (e) {
              _that.changeBtnStyle(this);
              _that.widget.chart().setResolution('1', function onReadyCallback () {});
              _that.widget.chart().setChartType(1);
            });
          this.widget.createButton()
            .attr('title', this.$t('kline.5m'))
            .text(this.$t('kline.5m'))
            .on('click', function (e) {
              _that.changeBtnStyle(this);
              _that.widget.chart().setResolution('5', function onReadyCallback () {});
              _that.widget.chart().setChartType(1);
            });
          this.widget.createButton().addClass('mybtn')
            .attr('title', this.$t('kline.15m'))
            .text(this.$t('kline.15m'))
            .on('click', function (e) {
              _that.changeBtnStyle(this);
              _that.widget.chart().setResolution('15', function onReadyCallback () {});
              _that.widget.chart().setChartType(1);
            });
          this.widget.createButton()
            .attr('title', this.$t('kline.30m'))
            .text(this.$t('kline.30m'))
            .on('click', function (e) {
              _that.changeBtnStyle(this);
              _that.widget.chart().setResolution('30', function onReadyCallback () {});
              _that.widget.chart().setChartType(1);
            });
          this.widget.createButton()
            .attr('title', this.$t('kline.1h'))
            .text(this.$t('kline.1h'))
            .on('click', function (e) {
              _that.changeBtnStyle(this);

              _that.widget.chart().setResolution('60', function onReadyCallback () {});
              _that.widget.chart().setChartType(1);
            });

          this.widget.createButton()
            .attr('title', this.$t('kline.1d'))
            .text(this.$t('kline.1d'))
            .on('click', function (e) {
              _that.changeBtnStyle(this);
              // $(this).parents(".left").children().find(".mydate").removeAttr("style");
              // $(this).css("background-color","#4e5b85");
              _that.widget.chart().setResolution('1D', function onReadyCallback () {});
              _that.widget.chart().setChartType(1);
            });
          this.widget.createButton()
            .attr('title', this.$t('kline.1w'))
            .text(this.$t('kline.1w'))
            .on('click', function (e) {
              _that.changeBtnStyle(this);
              // $(this).parents(".left").children().find(".mydate").removeAttr("style");
              // $(this).css("background-color","#4e5b85");
              _that.widget.chart().setResolution('1W', function onReadyCallback () {});
              _that.widget.chart().setChartType(1);
            }); */

        // that.$emit('chartReady');
        if (document.getElementById('trade_loading')) {
          document.getElementById('trade_loading').style.display = 'none';
        }
      });
    },
    // 获取配置
    getConfig: function() {
      // https://b.aitrade.ga/books/tradingview/book/UDF.html
      return {
        supports_search: false, //  请修改datafeed的searchSymbols函数
        supports_group_request: false, // 设置为true将无法进行单个商品解析
        supports_marks: false, // 请修改datafeed的getMarks函数
        supports_timescale_marks: false, // 请修改datafeed的getTimescaleMarks函数
        supports_time: false
      };
    },
    getBars: function(symbol, resolution, from, to, callback) {
      // symbol BTCUSDT 5
      // let fromStr = new Date(from * 1000).toLocaleString()
      // let toStr = new Date(to * 1000).toLocaleString()
      // 第一次getBars 的from：2017/6/25 to：2018/6/20
      // 请求数据
      const requestData = () => {
        this.reqInterval = this.parseInterval(resolution);
        window.localStorage.setItem('chart.interval', resolution);
        this.$emit('subscribeExchange', this.symbol, this.reqInterval);
        this._requestFirstKline(this.symbol, this.reqInterval, resolution, from, to, callback);
      };
      requestData();
    },
    getServerTime: function() {
      // 暂时由客户端生成时间
      return parseInt(Date.now() / 1000);
    },

    resolveTVSymbol: function(symbol) {
      // https://b.aitrade.ga/books/tradingview/book/Symbology.html
      return {
        name: symbol,
        'exchange-traded': '',
        'exchange-listed': '',
        timezone: 'Asia/Shanghai',
        minmov: 1,
        minmov2: 0,
        pointvalue: 1,
        fractional: false,
        session: '24x7',
        has_intraday: true,
        has_no_volume: false,
        description: symbol,
        pricescale: 1000000,
        ticker: symbol,
        has_weekly_and_monthly: true
        // 'supported_resolutions': []
      };
    },
    changeMarket: function(symbol) {
      this.reqInterval = this.parseInterval(this.interval);
      if (symbol !== this.symbol) {
        this.dataCache = {};
        this.symbol = symbol;
        this.widget.chart().setSymbol(this.symbol);
      }
    },
    parseInterval(interval) {
      let periodMap = {
        '1M': '1mn',
        '1W': '1w',
        // "03d": "3day",
        '1D': '1d',
        '720': '12h',
        '480': '8h',
        '360': '6h',
        '240': '4h',
        '120': '2h',
        '60': '1h',
        '30': '30m',
        '15': '15m',
        '5': '5m',
        // "3": "3min",
        '1': '1m'
      };
      return periodMap[interval];
    },
    initKline(currentMarket) {
      if (this.isUndefinedOrNullOrEmpty(window.localStorage.getItem('chart.interval'))) {
        window.localStorage.setItem('chart.interval', '30');
      }
      this.currentMarket = currentMarket;
      let symbol = this.currentMarket.symbol;
      this.init({ symbol: symbol, interval: window.localStorage.getItem('chart.interval') });
    },
    marketChange(currentMarket) {
      this.currentMarket = currentMarket;
      let symbol = this.currentMarket.symbol;
      this.changeMarket(symbol);
    },
    arrayToJSON(inArray) {
      let jsonArray = [];
      for (let i of inArray) {
        let obj = {};
        obj.time = Number(i[0]);
        obj.open = Number(i[1]);
        obj.close = Number(i[2]);
        obj.high = Number(i[3]);
        obj.low = Number(i[4]);
        obj.volume = Number(i[5]);
        obj.amount = Number(i[6]);
        obj.change = Number(i[7]);
        obj.price = Number(i[8]);
        jsonArray.push(obj);
      }
      return JSON.parse(JSON.stringify(jsonArray));
    },
    subscribeBars(symbolInfo, resolution, onRealtimeCallback, listenerGUID, onResetCacheNeededCallback, newVal = null) {
      this.reqInterval = this.parseInterval(resolution);
      this.onRealtimeCallback = onRealtimeCallback;
      // 订阅之前先取消订阅
      // this.unSubscribeKLine();
      // this.$socket.unsubscribe('getList');
      // this.$socket.subscribe('getList', res => {
      /* let data = this.arrayToJSON([["1580158976000", "179", "179", "179", "179", "12", "12", "12", "17"]]).reverse();
      for (let i = 0; i < data.length; i++) {
        let item = data[i];
        onRealtimeCallback(item);
      } */
      // });
      /* if (this.newKline !== null) {
        let data = this.arrayToJSON(newKline).reverse();
        for(let i = 0; i < data.length; i++) {
          let item = data[i];
          onRealtimeCallback(item);
        }
      } */
      /* let data2 = [{
          time: 1579796550000,
          open: 53.84,
          high: 7702.55,
          low: 7656.98,
          close: 7658.25,
          volume: 0.9834
        },{
          time: 1579796660000,
          open: 53.84,
          high: 7702.55,
          low: 7656.98,
          close: 7658.25,
          volume: 0.9834
        }]; */
      // this.lastSubscribeChannel = channel;
    },
    unsubscribeBars(listenerGUID) {},
    // 取消订阅k线
    unSubscribeKLine() {
      let lastSubscribeChannel = this.lastSubscribeChannel;
      if (lastSubscribeChannel) {
        this.$socket2.get(socketName.exchange).unSubscribe(lastSubscribeChannel, { cancel: lastSubscribeChannel });
      }
    },
    getZoomLevel() {
      this.zoom = Math.round(window.devicePixelRatio * 100);
    },
    getAccessContainers() {
      const element = document.getElementById('place-order-container');
      if (element) {
        this.placeOrderContainer = element;
      }

      const element2 = document.getElementById('market-pair-trade-details');
      if (element2) {
        this.activePairContainer = element2;
      }

      const element3 = document.getElementById('trade-view-container');
      if (element3) {
        this.parentContainer = element3;
      }

      const element4 = document.getElementById('left-container');
      if (element4) {
        this.leftContainer = element4;
      }

      const element5 = document.getElementById('trade-view-inner-container');
      if (element5) {
        this.tradingViewInnerContainer = element5;
      }

      const element6 = document.getElementById('depth-component-container');
      if (element6) {
        this.depthComponentContainer = element6;
      }

      if (element && element2 && element3 && element4 && element5 && element6) {
        return true;
      }

      return false;
    },
    getTradingViewContainer() {
      const element = document.getElementById('trade_chart_container');
      if (element) {
        this.tradingViewContainer = element;
      }
      return element;
    },
    resizeKline() {
      if (this.tradingViewContainer && this.placeOrderContainer) {
        // console.log('my height here: ', this.windowHeight, this.accessHeight);
        // console.log('window height',window.innerHeight);
        // this.tradingViewContainer.style.height = `${window.innerHeight - this.accessHeight}px`;
        // console.log('the height now: ', this.tradingViewContainer.style.height);
        const missOutMarginLeft = 9;
        const missOutMarginDepth = 3;
        this.tradingViewContainer.style.height = `${window.innerHeight - this.accessHeight}px`;

        this.leftContainer.style.height = `${this.tradingViewInnerContainer.offsetHeight +
          this.placeOrderContainer.offsetHeight +
          missOutMarginLeft}px`;
          
        this.depthComponentContainer.style.height = `${this.tradingViewInnerContainer.offsetHeight +
          this.placeOrderContainer.offsetHeight +
          missOutMarginDepth}px`;
      }
    },
    zoomOffset(value) {
      let response = 0;
      if (100 < this.zoom) {
        response = (value * (100 - this.zoom + 100)) / 100;
      } else if (100 > this.zoom) {
        response = value - value * ((this.zoom - 100) / 100);
      } else {
        response = value;
      }
      return response;
    }
  },
  computed: {
    // ...mapGetters([ getterTypes.Getter_Lang , 'getSocketStatus']),
    ...mapGetters([getterTypes.Getter_Lang, getterTypes.Getter_Current_Market]),
    accessHeight() {
      if (!this.placeOrderContainer && !this.activePairContainer) {
        return 0;
      }
      const navbarHeight = 48;
      const response = this.placeOrderContainer.offsetHeight + this.activePairContainer.offsetHeight + navbarHeight;
      return response;
    },
    windowHeight() {
      console.log('the offset height:', this.parentContainer.offsetHeight, this.parentContainer.innerHeight);
      if (100 < this.zoom) {
        return this.parentContainer.offsetHeight;
      } else {
        return this.parentContainer.clientHeight;
      }

      return this.parentContainer.offsetHeight;
    }
  },
  watch: {
    zoom(value) {
      this.resizeKline();
    },
    placeOrderContainer() {
      this.resizeKline();
    },
    tradingViewContainer() {
      this.resizeKline();
    },
    Getter_Current_Market(value) {
      this.marketChange(value);
      /*if(value){
          this.init({ symbol: value.symbol, interval: window.localStorage.getItem('chart.interval') });
        }*/
    },
    realTimeData(value) {
      if (0 < value.length) {
        for (let i = 0; i < value.length; i++) {
          let item = value[i];
          setTimeout(() => {
            // monitor kline performance
            if (typeof this.onRealtimeCallback === 'function') {
              this.onRealtimeCallback(item);
            }
          }, 750);
        }
      }
    },
    model(value) {
      if (value) {
        if (this.isUndefinedOrNullOrEmpty(window.localStorage.getItem('chart.interval'))) {
          window.localStorage.setItem('chart.interval', '30');
        }
        // this.klineData = value;
        // this.init({ symbol: this.activePair, interval: window.localStorage.getItem('chart.interval') });
      }
    }
  },
  mounted() {
    const self = this;
    let code = this.Getter_Lang;
    this.klineLang = this.langMap[code];

    if (this.isUndefinedOrNullOrEmpty(window.localStorage.getItem('chart.interval'))) {
      window.localStorage.setItem('chart.interval', '30');
    }

    const callback = () => {
      this.init({ symbol: this.activePair, interval: window.localStorage.getItem('chart.interval') });

      //get zoom level when enter page
      this.getZoomLevel();
      window.addEventListener('resize', event => {
        self.getZoomLevel();
      });
    };

    const interval = setInterval(() => {
      const response = this.getAccessContainers();
      if (response) {
        callback();
        clearInterval(interval);
      }
    }, 1000);
  },
  beforeDestroy() {
    // this.$socket.unsubscribe(`market.${this.symbol.toLowerCase()}.kline.${this.reqInterval}`, 'market-kline');
    // this.unSubscribeKLine();
    // this.$socket2.get(socketName.exchange).removeReConnectEvent('kLine_reConnect');
  }
};
</script>

<style lang="stylus" scoped>
@import './tradeview.scoped.styl';
</style>
